<div class="relative flex min-w-[220px] gap-x-2">
  <lib-input
    #dropdownControl
    #trigger="cdkOverlayOrigin"
    cdkOverlayOrigin
    class="group"
    [label]="labelText()"
    [readOnlyField]="readonly"
    labelPosition="above"
    [formControl]="innerControl"
    [placeholder]="placeholderText()"
    [background]="'white'"
    (click)="openDropdown()"
    (focusout)="onFocusOut($event)"
    [ffdPushTagOnClick]="{
      event: TagEvent.PatientSearchOpened
    }"
  >
    @if (!dropdownOpen() && patient() && !inputFocused()) {
      <lib-avatars [persons]="[patient()!]" [size]="32" leftIcon class="ms-[-8px]"></lib-avatars>
    }
    @if (innerControl.value && !inputFocused() && !readonly) {
      <button rightIcon class="hidden h-6 w-6 items-center justify-center rounded-full group-hover:flex" (click)="clearInput($event)">
        <svg-icon size="sm" key="px-24-x" class="text-primary-blue"></svg-icon>
      </button>
    }
  </lib-input>
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayWidth]="trigger.elementRef.nativeElement.offsetWidth"
    [cdkConnectedOverlayOrigin]="dropdownControl.inputContainer"
    [cdkConnectedOverlayOpen]="dropdownOpen()"
    [cdkConnectedOverlayPositions]="overlayPositionStrategy"
    [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
    (overlayOutsideClick)="onOverlayOutsideClick($event)"
  >
    <div
      #dropdownList
      class="flex w-full flex-col gap-3 overflow-hidden rounded-[28px] border-2 border-background-white bg-background-modal shadow-card backdrop-blur"
    >
      @if (!patients()) {
        @if (isLoading()) {
          <div class="flex items-center justify-center p-4">
            <ng-lottie currentcolor class="text-primary-blue" [options]="lottieOptions"></ng-lottie>
          </div>
        } @else if (innerControl.value) {
          <div class="flex items-center justify-center p-4">
            <p class="typo-h7-semibold text-text-primary">{{ noResultLabelText() }}</p>
          </div>
        }
      } @else if (patients() && !patients().length) {
        @if (isLoading()) {
          <div class="flex items-center justify-center p-4">
            <ng-lottie currentcolor class="text-primary-blue" [options]="lottieOptions"></ng-lottie>
          </div>
        } @else {
          <div class="flex items-center justify-center p-4">
            <p class="typo-h7-semibold text-text-primary">{{ noResultLabelText() }}</p>
          </div>
        }
      } @else if (patients()) {
        <cdk-virtual-scroll-viewport
          libDynamicVirtualViewportHeight
          [items]="patients()"
          [itemSize]="48"
          [height]="dropdownHeight()"
          [style.max-height.px]="dropdownMaxHeight()"
          class="min-h-[64px]"
          minBufferPx="100"
          maxBufferPx="100"
          libInfiniteScrollList
          (endReached)="onEndReached()"
        >
          @if (patients(); as participants) {
            <ng-container *cdkVirtualFor="let participant of participants">
              <button libInfiniteScrollListItem class="flex justify-between gap-2" (click)="selectItem(participant)">
                <div
                  class="flex items-center gap-2"
                  [ngClass]="{
                    'font-semibold': participant.id === patient()?.id
                  }"
                >
                  <lib-avatars [persons]="[participant]" [size]="32"></lib-avatars>
                  <div class="flex flex-col items-start">
                    <p
                      class="typo-h4-light text-text-primary"
                      [ngClass]="{
                        'font-semibold': participant.id === patient()?.id
                      }"
                    >
                      {{ participant.firstName }} {{ participant.lastName }}
                    </p>
                    <p
                      class="typo-h7-light text-text-secondary"
                      [ngClass]="{
                        'font-semibold': participant.id === patient()?.id
                      }"
                    >
                      {{ participant.birthDate | date: 'dd/MM/yyyy' : '+0000' }}
                    </p>
                  </div>
                </div>
                @if (participant.id === patient()?.id) {
                  <div class="flex h-6 w-6 items-center justify-center rounded-full bg-other-dropdown-check">
                    <svg-icon size="sm" key="px-16-check" class="text-secondary-green"></svg-icon>
                  </div>
                }
              </button>
            </ng-container>

            @if (isLoading()) {
              <div class="flex items-center justify-center p-4">
                <ng-lottie currentcolor class="text-primary-blue" [options]="lottieOptions"></ng-lottie>
              </div>
            }
          }
        </cdk-virtual-scroll-viewport>
      }
    </div>
  </ng-template>
</div>
